import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { Required } from '@app/core/decorators/required'
import { Confirmable } from '@app/modules/ui/models/confirmable'
import { UIModule } from '@ui/ui.module'

@Component({
  selector: 'sb-message-photo-album-disapproved-modal',
  templateUrl: './message-photo-album-disapproved-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoAlbumDisapprovedModalComponent extends Confirmable {
  @Required @Input() count!: number
  @Required @Input() username!: string
}
